import { Box, Col, Row } from '@opendoor/atoms/box';
import { Image } from '@opendoor/atoms/image';
import { Link } from '@opendoor/atoms/link';
import { Text } from '@opendoor/atoms/text';
import { IconChevronRight, IconLogout2, IconShield, IconTruckDelivery } from '@tabler/icons-react';

import {
  PDP_GUARANTEE_BADGE_SOURCES,
  PDP_GUARANTEE_BADGE_SRCSET,
  PDP_GUARANTEE_BADGE_URL,
} from './media';

const PROTECTIONS = [
  { icon: IconTruckDelivery, label: 'Early move in' },
  { icon: IconShield, label: '100-Day Warranty' },
  { icon: IconLogout2, label: 'Free cancellation' },
];

export const PdpGuaranteeCard = () => (
  // 51px here + the column's 24px gap puts the badge's visible top 32px below the card above.
  <Box className="w-full pt-[51px]">
    <Col className="relative isolate w-full items-center gap-6 rounded-2xl bg-[#EAE8E0] px-6 pb-6 pt-[95.5px]">
      {/* Figma: 300px circle (#FDFCF9) whose bottom sits 28px above the card's bottom edge. */}
      <Box
        aria-hidden
        className="pointer-events-none absolute inset-0 -z-10 overflow-hidden rounded-2xl"
      >
        <Box className="absolute bottom-7 left-1/2 size-[300px] -translate-x-1/2 rounded-full bg-[#FDFCF9] blur-[40px]" />
      </Box>
      <Image
        src={PDP_GUARANTEE_BADGE_URL}
        alt="Opendoor Guarantee"
        width={128}
        height={159}
        srcSet={PDP_GUARANTEE_BADGE_SRCSET}
        sources={PDP_GUARANTEE_BADGE_SOURCES}
        // The <picture> wrapper is the positioned element so its <source> tags never join the card's layout.
        // The export has 16.5px of clear space above the badge; 59.5 puts its visible top 43px above the card.
        pictureClassName="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-[59.5px]"
        className="block"
      />
      <Col className="items-center gap-2">
        <Text as="p" className="text-center text-label-md text-[#3C3733]">
          The Opendoor Guarantee
        </Text>
        <Text as="p" className="flex items-center gap-3 text-body-sm text-[#696560]">
          Included with this home
          <Link
            href="https://help.opendoor.com/buying/making-an-offer/opendoor-guarantee"
            target="_blank"
            rel="noopener noreferrer"
            analyticsName="cosmos-marketplace-pdp-guarantee-learn-more"
            aria-label="Learn more about The Opendoor Guarantee"
            className="group flex items-center gap-1! text-body-sm text-[#3C3733]! no-underline! hover:text-[#3C3733]!"
          >
            Learn more
            <IconChevronRight
              size={18}
              className="transition-transform duration-150 group-hover:translate-x-1"
            />
          </Link>
        </Text>
      </Col>
      <Row className="flex-wrap justify-center gap-1">
        {PROTECTIONS.map(({ icon: Icon, label }) => (
          <Row key={label} className="items-center gap-2 rounded-full bg-od-bg-primary px-3 py-2">
            <Icon size={16} className="text-od-content-tertiary" />
            <Text as="span" className="text-body-xs">
              {label}
            </Text>
          </Row>
        ))}
      </Row>
    </Col>
  </Box>
);
